import * as React from 'react';
import { useCallback } from 'react';

import { compose } from 'recompose';

import { withTheme } from '@coursera/cds-core';

import usePathname from 'bundles/authentication-common/hooks/usePathname';
import localStorageEx from 'bundles/common/utils/localStorageEx';
import { LOCAL_STORAGE_EOI_EMBEDDED_SIGN_IN_DATA } from 'bundles/expression-of-interest/constants';
import type { Props as EmbeddedRegFormProps } from 'bundles/xddp/components/shared/EmbeddedRegForm';
import EmbeddedRegForm from 'bundles/xddp/components/shared/EmbeddedRegForm';

type Props = EmbeddedRegFormProps & { degreeId: string };

export function DLPEmbeddedRegFormContainer({ degreeId, ...rest }: Props): React.ReactElement {
  const pathname = usePathname();

  const onRegSuccess = useCallback<() => $TSFixMe>(() => {
    // Set data to local storage to measure complete EOI flow
    localStorageEx.setItem(
      LOCAL_STORAGE_EOI_EMBEDDED_SIGN_IN_DATA,
      { ts: Date.now(), degreeId, pathname, slug: rest?.slug },
      JSON.stringify
    );
  }, [pathname, degreeId, rest?.slug]);

  return <EmbeddedRegForm {...rest} onRegSuccess={onRegSuccess} trackingProductId={degreeId.replace('base~', '')} />;
}

export default compose<Props, EmbeddedRegFormProps & { degreeId: string }>(withTheme)(DLPEmbeddedRegFormContainer);
